export const PHONE = "(407) 952-4487";
export const PHONE_HREF = "tel:+14079524487";
export const EMAIL = "sundayseasolutions@gmail.com";
export const AREAS = "Orlando • Lakeland • Tampa";

export const WA = (extra = "") =>
  `https://wa.me/14079524487?text=${encodeURIComponent(
    "Hi SundaySea! I'd like a free painting estimate. My project: " + extra
  )}`;

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const HERO_SLIDES = [
  { img: "/images/pool-exterior.jpg", alt: "Exterior repaint — painted brick home with pool" },
  { img: "/images/house-dusk.jpg", alt: "Two-story home exterior at dusk" },
  { img: "/images/kitchen.jpg", alt: "Luxury interior repaint — bright kitchen" },
];

export const STATS = [
  { k: "20+", v: "Years · Central Florida" },
  { k: "5.0", v: "Rated · Google & HomeAdvisor" },
  { k: "FL", v: "Licensed & Insured Contractor" },
  { k: "100%", v: "Locally Owned · Orlando, Lakeland & Tampa" },
];

export const SERVICES = [
  {
    tag: "RESIDENTIAL EXTERIOR",
    title: "Built for the Florida sun.",
    img: "/images/garage-navy.jpg",
    alt: "Stucco home exterior with freshly painted navy garage door",
    desc: "Protect your home from intense sun and humidity. We use premium weather-resistant coatings that prevent cracking, fading, and moisture damage.",
    testid: "service-card-residential",
  },
  {
    tag: "LUXURY INTERIOR",
    title: "Crisp lines. Flawless finish.",
    img: "/images/kitchen.jpg",
    alt: "Bright repainted kitchen with white cabinetry",
    desc: "Kitchens, living rooms, and master suites transformed into high-end spaces. Smooth finishes, sharp cut-ins, no detail overlooked.",
    testid: "service-card-interior",
  },
  {
    tag: "SPECIALTY & CUSTOM",
    title: "Bold color. Premium finishes.",
    img: "/images/theater.jpg",
    alt: "High-contrast home theater painted in deep navy",
    desc: "From high-contrast home theaters to elegant accent walls and modern home offices — we master complex schemes and premium finishes.",
    testid: "service-card-specialty",
  },
  {
    tag: "COMMERCIAL",
    title: "On time. On brand. Open for business.",
    img: "/images/commercial-blue.jpg",
    alt: "Commercial building exterior with freshly painted brick and blue metal roof",
    desc: "Reliable, professional painting for Central Florida businesses. We minimize downtime and maximize curb appeal — done on your schedule.",
    testid: "service-card-commercial",
  },
];

export const GALLERY = [
  { img: "/images/kitchen.jpg", cat: "interiors", alt: "Polished modern kitchen repaint" },
  { img: "/images/garage-navy.jpg", cat: "exteriors", alt: "Garage door painted navy" },
  { img: "/images/theater.jpg", cat: "interiors", alt: "Moody home theater" },
  { img: "/images/bathroom.jpg", cat: "interiors", alt: "Master bath refresh" },
  { img: "/images/pool-exterior.jpg", cat: "exteriors", alt: "Painted brick poolside exterior" },
  { img: "/images/hallway-blue.jpg", cat: "interiors", alt: "Arched hallway with wainscoting" },
  { img: "/images/outdoor-kitchen.jpg", cat: "exteriors", alt: "Outdoor kitchen repaint" },
  { img: "/images/hallway-white.jpg", cat: "interiors", alt: "Crisp trim and doors hallway" },
  { img: "/images/garage-maroon.jpg", cat: "exteriors", alt: "Garage door repaint in maroon" },
  { img: "/images/office-green.jpg", cat: "interiors", alt: "Office interior in sage green" },
  { img: "/images/exterior-tan-pool.jpg", cat: "exteriors", alt: "Two-story stucco home by the pool" },
  { img: "/images/exterior-gray.jpg", cat: "exteriors", alt: "Gray stucco home with charcoal garage" },
  { img: "/images/exterior-gray-side.jpg", cat: "exteriors", alt: "Arched windows with white trim" },
  { img: "/images/exterior-white.jpg", cat: "exteriors", alt: "Fresh white stucco home corner" },
  { img: "/images/commercial-blue.jpg", cat: "exteriors", alt: "Commercial brick building with metal roof" },
  { img: "/images/vet-clinic.jpg", cat: "interiors", alt: "Vet clinic accent wall" },
  { img: "/images/commercial-front.jpg", cat: "exteriors", alt: "Commercial entrance repaint" },
  { img: "/images/house-dusk.jpg", cat: "exteriors", alt: "Two-story exterior at dusk" },
  { img: "/images/exterior-gray-2.jpg", cat: "exteriors", alt: "Gray two-story home with balustrade" },
  { img: "/images/exterior-cream.jpg", cat: "exteriors", alt: "Cream stucco home with palm" },
  { img: "/images/door-blue.jpg", cat: "exteriors", alt: "Front door painted blue" },
  { img: "/images/shutters-red.jpg", cat: "exteriors", alt: "Shutters and stone accents" },
  { img: "/images/house-taupe.jpg", cat: "exteriors", alt: "Two-story taupe exterior" },
  { img: "/images/porch-blue.jpg", cat: "exteriors", alt: "Blue stucco porch columns" },
  { img: "/images/archway-blue.jpg", cat: "exteriors", alt: "Community archway monument" },
];

export const PROCESS = [
  {
    n: "01",
    title: "Free On-Site Consultation",
    desc: "We visit your property, assess scope and surfaces, and deliver a transparent, line-item estimate — no pressure.",
  },
  {
    n: "02",
    title: "Meticulous Prep & Execution",
    desc: "We mask, tape, and protect every surface before a single brush touches the wall. Then we apply premium coats with precision.",
  },
  {
    n: "03",
    title: "Final Walkthrough",
    desc: "We don't pack up until you've inspected the work and signed off — 100% satisfaction or we make it right.",
  },
];

export const PREP_LIST = [
  "Furniture moved, floors covered, fixtures masked",
  "Hairline cracks, holes, and surface flaws repaired",
  "Premium primer + 2 finish coats — never thinned",
  "Daily site cleanup. Zero paint splatters on your trim.",
];

export const TESTIMONIAL = {
  quote: "They protected our hardwood like it was theirs. Zero mess, perfect lines.",
  author: "— MARCUS T., WINTER PARK",
};

export const NAV_LINKS = [
  ["Services", "#services", "nav-services"],
  ["Our Process", "#process", "nav-process"],
  ["Gallery", "#gallery", "nav-gallery"],
  ["About", "#difference", "nav-about"],
  ["Contact", "#contact", "nav-contact"],
];
